import { Component, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { animate, style, transition, trigger } from '@angular/animations';
import { ToasterComponent } from 'component-library';
import { ToasterConfig, ToasterService} from 'shared';

@Component({
  selector: 'lib-toaster-wrapper',
  standalone: true,
  templateUrl: './toaster-wrapper.component.html',
  styleUrls: ['./toaster-wrapper.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('listAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(100%)' }),
        animate('0.5s ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      transition(':leave', [animate('0.5s ease-in', style({ opacity: 0, transform: 'translateY(100%)' }))])
    ])
  ],
  imports: [CommonModule, ToasterComponent]
})
export class ToasterWrapperComponent {
  toasters = this.toasterService.getToasters();

  constructor(private toasterService: ToasterService) {}

  removeToaster($event: ToasterConfig) {
    this.toasterService.removeToaster($event);
  }
}
